import { useCallback, useSyncExternalStore } from 'react';
import { useQueryClient } from 'react-query';

// Both the feed card and details share the same in-flight action.
// Read the current snapshot so immediately completed requests cannot leave stale loading state.
export default function useLeadMutationPending(action: 'lead-favorite' | 'lead-feedback', id: number) {
    const queryClient = useQueryClient();
    const subscribe = useCallback(
        (onChange: () => void) => queryClient.getMutationCache().subscribe(onChange),
        [queryClient]
    );
    const getSnapshot = useCallback(
        () => queryClient.isMutating({ mutationKey: [action, id] }) > 0,
        [queryClient, action, id]
    );
    return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
